import React from "react";
var BulletSvg = function BulletSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4.792",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BulletSvg.defaultProps = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronDownSvg = function ChevronDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 19L0 7.44428L1.5 6L12 16.11L22.5 6.00001L24 7.44431L11.9985 19Z",
    fill: "currentColor"
  }));
};
ChevronDownSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronLeftSvg = function ChevronLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 11.9985L16.5557 -6.31316e-08L18 1.5L7.89001 12L18 22.5L16.5557 24L5 11.9985Z",
    fill: "currentColor"
  }));
};
ChevronLeftSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronRightSvg = function ChevronRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 12.0015L7.44428 24L6 22.5L16.11 12L6.00001 1.50002L7.44431 -6.31327e-08L19 12.0015Z",
    fill: "currentColor"
  }));
};
ChevronRightSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronUpSvg = function ChevronUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.0015 5L24 16.5557L22.5 18L12 7.89002L1.50002 18L-1.26265e-07 16.5557L12.0015 5Z",
    fill: "currentColor"
  }));
};
ChevronUpSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CloseSvg = function CloseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M24 22.5882L22.5883 24L12 13.4118L1.41177 24L4.24341e-05 22.5882L10.5882 12L-9.87363e-07 1.41177L1.41177 -6.17103e-08L12 10.5882L22.5883 -3.34123e-05L24 1.41173L13.4118 12L24 22.5882Z",
    fill: "currentColor"
  }));
};
CloseSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HomeSvg = function HomeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 22H8V14H16V22H21V9L12 2.25L3 9V22ZM1 24V8L12 0L23 8V24H14V16H10V24H1Z",
    fill: "currentColor"
  }));
};
HomeSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var InformationSvg = function InformationSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.0527 18H12.9473V10.7368H11.0527V18ZM12 8.57491C12.2891 8.57491 12.5314 8.47714 12.7269 8.2816C12.9225 8.08606 13.0202 7.84376 13.0202 7.55468C13.0202 7.26563 12.9225 7.02332 12.7269 6.82777C12.5314 6.63223 12.2891 6.53446 12 6.53446C11.7109 6.53446 11.4686 6.63223 11.2731 6.82777C11.0775 7.02332 10.9798 7.26563 10.9798 7.55468C10.9798 7.84376 11.0775 8.08606 11.2731 8.2816C11.4686 8.47714 11.7109 8.57491 12 8.57491ZM12.0021 24C10.3424 24 8.78236 23.6851 7.32198 23.0552C5.86157 22.4253 4.59123 21.5704 3.51096 20.4906C2.43066 19.4108 1.57543 18.141 0.945255 16.6813C0.315085 15.2215 0 13.6618 0 12.0021C0 10.3424 0.314948 8.78236 0.944845 7.32198C1.57474 5.86157 2.42959 4.59123 3.50938 3.51096C4.58919 2.43066 5.85897 1.57543 7.31872 0.945255C8.77845 0.315085 10.3382 0 11.9979 0C13.6576 0 15.2176 0.314948 16.678 0.944844C18.1384 1.57474 19.4088 2.42959 20.489 3.50938C21.5693 4.58919 22.4246 5.85897 23.0547 7.31872C23.6849 8.77845 24 10.3382 24 11.9979C24 13.6576 23.6851 15.2176 23.0552 16.678C22.4253 18.1384 21.5704 19.4088 20.4906 20.489C19.4108 21.5693 18.141 22.4246 16.6813 23.0547C15.2215 23.6849 13.6618 24 12.0021 24ZM12 22.1053C14.8211 22.1053 17.2105 21.1263 19.1684 19.1684C21.1263 17.2105 22.1053 14.8211 22.1053 12C22.1053 9.17894 21.1263 6.78946 19.1684 4.83156C17.2105 2.87366 14.8211 1.89471 12 1.89471C9.17894 1.89471 6.78946 2.87366 4.83156 4.83156C2.87366 6.78946 1.89471 9.17894 1.89471 12C1.89471 14.8211 2.87366 17.2105 4.83156 19.1684C6.78946 21.1263 9.17894 22.1053 12 22.1053Z",
    fill: "currentColor"
  }));
};
InformationSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MenuSvg = function MenuSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 20V18H24V20H0ZM0 13V11H24V13H0ZM0 6.05711V4H24V6.05711H0Z",
    fill: "currentColor"
  }));
};
MenuSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusSvg = function MinusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 13V11H24V13H0Z",
    fill: "currentColor"
  }));
};
MinusSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var NegativeSvg = function NegativeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.9757C12.2891 17.9757 12.5314 17.8779 12.7269 17.6824C12.9225 17.4868 13.0202 17.2445 13.0202 16.9555C13.0202 16.6664 12.9225 16.4241 12.7269 16.2286C12.5314 16.033 12.2891 15.9353 12 15.9353C11.7109 15.9353 11.4686 16.033 11.2731 16.2286C11.0775 16.4241 10.9798 16.6664 10.9798 16.9555C10.9798 17.2445 11.0775 17.4868 11.2731 17.6824C11.4686 17.8779 11.7109 17.9757 12 17.9757ZM11.0527 13.3603H12.9473V5.78136H11.0527V13.3603ZM12.0021 24C10.3424 24 8.78236 23.6851 7.32198 23.0552C5.86157 22.4253 4.59123 21.5704 3.51096 20.4906C2.43066 19.4108 1.57543 18.141 0.945255 16.6813C0.315085 15.2215 0 13.6618 0 12.0021C0 10.3424 0.314948 8.78236 0.944845 7.32198C1.57474 5.86157 2.42959 4.59123 3.50938 3.51096C4.58919 2.43066 5.85897 1.57543 7.31872 0.945255C8.77845 0.315085 10.3382 0 11.9979 0C13.6576 0 15.2176 0.314948 16.678 0.944844C18.1384 1.57474 19.4088 2.42959 20.489 3.50938C21.5693 4.58919 22.4246 5.85897 23.0547 7.31872C23.6849 8.77845 24 10.3382 24 11.9979C24 13.6576 23.6851 15.2176 23.0552 16.678C22.4253 18.1384 21.5704 19.4088 20.4906 20.489C19.4108 21.5693 18.141 22.4246 16.6813 23.0547C15.2215 23.6849 13.6618 24 12.0021 24ZM12 22.1053C14.8211 22.1053 17.2105 21.1263 19.1684 19.1684C21.1263 17.2105 22.1053 14.8211 22.1053 12C22.1053 9.17894 21.1263 6.78946 19.1684 4.83156C17.2105 2.87366 14.8211 1.89471 12 1.89471C9.17894 1.89471 6.78946 2.87366 4.83156 4.83156C2.87366 6.78946 1.89471 9.17894 1.89471 12C1.89471 14.8211 2.87366 17.2105 4.83156 19.1684C6.78946 21.1263 9.17894 22.1053 12 22.1053Z",
    fill: "currentColor"
  }));
};
NegativeSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PadlockSvg = function PadlockSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.71429 24C4.24286 24 3.83929 23.8321 3.50357 23.4964C3.16786 23.1607 3 22.7571 3 22.2857V9.88571C3 9.41429 3.16786 9.01071 3.50357 8.675C3.83929 8.33929 4.24286 8.17143 4.71429 8.17143H6.71429V5.42857C6.71429 3.92667 7.24387 2.64643 8.30303 1.58786C9.36219 0.529286 10.6431 0 12.1459 0C13.6486 0 14.9286 0.529286 15.9857 1.58786C17.0429 2.64643 17.5714 3.92667 17.5714 5.42857V8.17143H19.5714C20.0429 8.17143 20.4464 8.33929 20.7821 8.675C21.1179 9.01071 21.2857 9.41429 21.2857 9.88571V22.2857C21.2857 22.7571 21.1179 23.1607 20.7821 23.4964C20.4464 23.8321 20.0429 24 19.5714 24H4.71429ZM4.71429 22.2857H19.5714V9.88571H4.71429V22.2857ZM12.1477 18.2857C12.754 18.2857 13.2714 18.0759 13.7 17.6563C14.1286 17.2366 14.3429 16.7322 14.3429 16.1429C14.3429 15.5714 14.127 15.0524 13.6952 14.5857C13.2634 14.119 12.7444 13.8857 12.1381 13.8857C11.5317 13.8857 11.0143 14.119 10.5857 14.5857C10.1571 15.0524 9.94286 15.5762 9.94286 16.1571C9.94286 16.7381 10.1587 17.2381 10.5905 17.6571C11.0223 18.0762 11.5413 18.2857 12.1477 18.2857ZM8.42857 8.17143H15.8571V5.42857C15.8571 4.39682 15.4964 3.51984 14.7748 2.79763C14.0532 2.0754 13.177 1.71429 12.1462 1.71429C11.1154 1.71429 10.2381 2.0754 9.51429 2.79763C8.79048 3.51984 8.42857 4.39682 8.42857 5.42857V8.17143Z",
    fill: "currentColor"
  }));
};
PadlockSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlusSvg = function PlusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 24V13H0V11H11V0H13V11H24V13H13V24H11Z",
    fill: "currentColor"
  }));
};
PlusSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PositiveSvg = function PositiveSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.2073 17.3733L18.6996 8.88097L17.3684 7.54982L10.2073 14.711L6.60728 11.111L5.27613 12.4421L10.2073 17.3733ZM12.0021 24C10.3424 24 8.78236 23.6851 7.32198 23.0552C5.86157 22.4253 4.59123 21.5704 3.51096 20.4906C2.43066 19.4108 1.57543 18.141 0.945255 16.6813C0.315085 15.2215 0 13.6618 0 12.0021C0 10.3424 0.314948 8.78236 0.944845 7.32198C1.57474 5.86157 2.42959 4.59123 3.50938 3.51096C4.58919 2.43066 5.85897 1.57543 7.31872 0.945255C8.77845 0.315085 10.3382 0 11.9979 0C13.6576 0 15.2176 0.314948 16.678 0.944844C18.1384 1.57474 19.4088 2.42959 20.489 3.50938C21.5693 4.58919 22.4246 5.85897 23.0547 7.31872C23.6849 8.77845 24 10.3382 24 11.9979C24 13.6576 23.6851 15.2176 23.0552 16.678C22.4253 18.1384 21.5704 19.4088 20.4906 20.489C19.4108 21.5693 18.141 22.4246 16.6813 23.0547C15.2215 23.6849 13.6618 24 12.0021 24ZM12 22.1053C14.8211 22.1053 17.2105 21.1263 19.1684 19.1684C21.1263 17.2105 22.1053 14.8211 22.1053 12C22.1053 9.17894 21.1263 6.78946 19.1684 4.83156C17.2105 2.87366 14.8211 1.89471 12 1.89471C9.17894 1.89471 6.78946 2.87366 4.83156 4.83156C2.87366 6.78946 1.89471 9.17894 1.89471 12C1.89471 14.8211 2.87366 17.2105 4.83156 19.1684C6.78946 21.1263 9.17894 22.1053 12 22.1053Z",
    fill: "currentColor"
  }));
};
PositiveSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SearchSvg = function SearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.5289 24L13.7611 15.2322C13.0631 15.8085 12.2604 16.2595 11.353 16.5852C10.4456 16.9109 9.50691 17.0738 8.53689 17.0738C6.15093 17.0738 4.13163 16.2477 2.47898 14.5954C0.826326 12.9432 0 10.9244 0 8.53909C0 6.15374 0.826117 4.13421 2.47835 2.48051C4.13058 0.826838 6.14938 0 8.53473 0C10.9201 0 12.9396 0.826326 14.5933 2.47898C16.247 4.13163 17.0738 6.15093 17.0738 8.53689C17.0738 9.53376 16.9065 10.4859 16.5718 11.3933C16.2371 12.3007 15.7906 13.0899 15.2322 13.7611L24 22.5289L22.5289 24ZM8.53689 14.9799C10.3356 14.9799 11.8591 14.3557 13.1074 13.1074C14.3557 11.8591 14.9799 10.3356 14.9799 8.53689C14.9799 6.73822 14.3557 5.21472 13.1074 3.96639C11.8591 2.71806 10.3356 2.0939 8.53689 2.0939C6.73822 2.0939 5.21472 2.71806 3.96639 3.96639C2.71809 5.21472 2.09393 6.73822 2.09393 8.53689C2.09393 10.3356 2.71809 11.8591 3.96639 13.1074C5.21472 14.3557 6.73822 14.9799 8.53689 14.9799Z",
    fill: "currentColor"
  }));
};
SearchSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TickSvg = function TickSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.77843 20.1066L0 12.3284L1.41447 10.9142L7.77843 17.2782L22.0566 3L23.4708 4.4143L7.77843 20.1066Z",
    fill: "currentColor"
  }));
};
TickSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WarningSvg = function WarningSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 22L12 1L24 22H0ZM3 20H21L12 4.55212L3 20ZM12 18.5332C12.271 18.5332 12.4981 18.4416 12.6814 18.2583C12.8647 18.075 12.9563 17.8478 12.9563 17.5769C12.9563 17.3059 12.8647 17.0788 12.6814 16.8955C12.4981 16.7122 12.271 16.6205 12 16.6205C11.729 16.6205 11.5019 16.7122 11.3186 16.8955C11.1353 17.0788 11.0437 17.3059 11.0437 17.5769C11.0437 17.8478 11.1353 18.075 11.3186 18.2583C11.5019 18.4416 11.729 18.5332 12 18.5332ZM11.112 15.4365H12.888V9.51612H11.112V15.4365Z",
    fill: "currentColor"
  }));
};
WarningSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var icons = {
  bullet: BulletSvg,
  chevron_down: ChevronDownSvg,
  chevron_left: ChevronLeftSvg,
  chevron_right: ChevronRightSvg,
  chevron_up: ChevronUpSvg,
  close: CloseSvg,
  cross: CloseSvg,
  home: HomeSvg,
  information: InformationSvg,
  menu: MenuSvg,
  minus: MinusSvg,
  negative: NegativeSvg,
  padlock: PadlockSvg,
  plus: PlusSvg,
  positive: PositiveSvg,
  search: SearchSvg,
  tick: TickSvg,
  warning: WarningSvg
};
export default icons;